import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  ApiResponseModel,
  ApiVisa, Core2Config
} from 'blg-akaun-ts-lib';
import { Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class DropDownService {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'drop-down';

  protected apiUrl: string;
  protected api_domain_url: string;
  protected endpoint_path: string;

  protected httpClient: HttpClient;

  constructor(http: HttpClient
  ) {
    this.apiUrl = this.url;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'drop-down';
    this.httpClient = http;
  }

  public getApiUrl(apiVisa: ApiVisa) {
    let url = this.apiUrl;
    if (this.endpoint_path && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + this.endpoint_path;
    }
    return url;
  }

  public getHttpHeader(apiVisa: ApiVisa) {
    apiVisa.applet_code = apiVisa.applet_code ? apiVisa.applet_code : 'none';
    apiVisa.tenantCode = apiVisa.tenantCode ? apiVisa.tenantCode : '';

    const httpOptions = {
      headers: new HttpHeaders({
        authorization: apiVisa.jwt_secret,
        tenantCode: apiVisa.tenantCode, /// this will be removed in the future
        appId: apiVisa.applet_code, /// this will be removed in the future
      })
    };

    return httpOptions;
  }


  public get(title: string, inputModel: any, apiVisa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url = this.getApiUrl(apiVisa);
    let formData = {
      // "keyword":"",
      // "orderBy":"code",
      // "order":"ASC",
      // "limit":"1500",
      // "filterLogical": "OR",
      // "filters" : {
      //     "namespace": "FI_ITEM_CATEGORY",
      //     "status":"ACTIVE"
      // }
    };

    if (inputModel) formData = inputModel;
    
    url += "/" + title;
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      formData,
      this.getHttpHeader(apiVisa)
    );
  }
}
